module.exports = __webpack_public_path__ + "img/cq1.4e5f03d0.webp";